import { Component } from '@angular/core';

import { CommonModule } from '@angular/common';

import {
    Router,
    RouterOutlet,
    NavigationEnd
} from '@angular/router';

import { filter } from 'rxjs/operators';

import { Navbar } from './shared/navbar/navbar';
import { Footer } from './shared/footer/footer';


@Component({
    selector: 'app-root',

    standalone: true,

    imports: [
        CommonModule,
        RouterOutlet,
        Navbar,
        Footer
    ],

    templateUrl: './app.html',

    styleUrls: ['./app.scss']
})
export class App {

    isAdmin = false;


    constructor(
        private router: Router
    ) {

        this.updateTheme();


        this.router.events
            .pipe(
                filter(
                    event =>
                        event instanceof NavigationEnd
                )
            )
            .subscribe(() => {

                this.updateTheme();

            });

    }


    private updateTheme(): void {

        this.isAdmin =
            this.router.url.startsWith('/admin');


        if (this.isAdmin) {

            document.body.classList.add(
                'admin-theme'
            );

        } else {

            document.body.classList.remove(
                'admin-theme'
            );

        }

    }

}